import { defineMessages } from 'react-intl'

export const towingJobFilterMessages = defineMessages({
  filtersButtonLabel: {
    id: 'towingJobFilter.filtersButtonLabel',
    defaultMessage: 'Suodattimet',
  },
  quickFilterHeading: {
    id: 'towingJobFilter.quickFilterHeading',
    defaultMessage: 'Työlistauksen pikasuodatus',
  },
  filteringButton: {
    id: 'towingJobFilter.filteringButton',
    defaultMessage: 'Suodatetaan...',
  },
  resetButton: {
    id: 'towingJobFilter.resetButton',
    defaultMessage: 'Palauta oletussuodatus',
  },
  searchPlaceholder: {
    id: 'towingJobFilter.searchPlaceholder',
    defaultMessage: 'Etsi...',
  },
  closeAll: {
    id: 'towingJobFilter.closeAll',
    defaultMessage: 'Sulje kaikki',
  },
  openAll: {
    id: 'towingJobFilter.openAll',
    defaultMessage: 'Avaa kaikki',
  },
  selectPlaceholder: {
    id: 'towingJobFilter.select.placeholder',
    defaultMessage: 'Valitse...',
  },
  moreSelected: {
    id: 'towingJobFilter.more_selected',
    defaultMessage: '+ {count} Muuta valittu',
  },
  jobDayLabel: {
    id: 'towingJobFilter.jobDay.label',
    defaultMessage: 'Työn päivä',
  },
  jobDayYesterday: {
    id: 'towingJobFilter.jobDay.yesterday',
    defaultMessage: 'Eilen',
  },
  jobDayToday: {
    id: 'towingJobFilter.jobDay.today',
    defaultMessage: 'Tänään',
  },
  jobDayTomorrow: {
    id: 'towingJobFilter.jobDay.tomorrow',
    defaultMessage: 'Huomenna',
  },
  jobDayHidePreOrders: {
    id: 'towingJobFilter.jobDay.hidePreOrders',
    defaultMessage: 'Piilota ennakot',
  },
  jobTypeLabel: {
    id: 'towingJobFilter.jobType.label',
    defaultMessage: 'Työn tyyppi',
  },
  operatorLabel: {
    id: 'towingJobFilter.operator.label',
    defaultMessage: 'Operaattori',
  },
  priorityLabel: {
    id: 'towingJobFilter.priority.label',
    defaultMessage: 'Prioriteetti',
  },
  priorityNone: {
    id: 'towingJobFilter.priority.none',
    defaultMessage: 'Ei priorisoitu',
  },
  priorityRed: {
    id: 'towingJobFilter.priority.red',
    defaultMessage: 'Punainen',
  },
  priorityYellow: {
    id: 'towingJobFilter.priority.yellow',
    defaultMessage: 'Keltainen',
  },
  priorityGreen: {
    id: 'towingJobFilter.priority.green',
    defaultMessage: 'Vihreä',
  },
  stationLabel: {
    id: 'towingJobFilter.station.label',
    defaultMessage: 'Asemapaikka',
  },
  statusLabel: {
    id: 'towingJobFilter.status.label',
    defaultMessage: 'Työn tila',
  },
  statusAll: {
    id: 'towingJobFilter.status.all',
    defaultMessage: 'Kaikki',
  },
  statusCompleted: {
    id: 'towingJobFilter.status.completed',
    defaultMessage: 'Valmiit',
  },
  statusOpen: {
    id: 'towingJobFilter.status.open',
    defaultMessage: 'Avoimet',
  },
})
